import { createApp } from 'vue'
import App from './App.vue'
import '@fortawesome/fontawesome-free/css/all.css';
import './styles/globals.css'

createApp(App).mount('#app')
